import { inject, Injectable } from '@angular/core';
import { IEnvironment } from './environment.interface';
import { HttpClient } from '@angular/common/http';
import { map, Observable, switchMap, tap } from 'rxjs';
import { PcObjectStringConvert } from '@pc/shared';
import { LanguageCode, TranslationService } from '@pc/translation';
import { TranslationLoader } from '../app.config';
import { TagInjectorService } from '@pc/meta-tag-injector';
import { ERecaptchaEnum, RecaptchaService } from '@pc/recaptcha-client-side';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private env!: IEnvironment;
  private http = inject(HttpClient);
  private translation = inject(TranslationService);
  private pcObjectStringConvert = inject(PcObjectStringConvert);
  private tagInjectorService = inject(TagInjectorService);
  private recaptchaService = inject(RecaptchaService);

  public get environment(): IEnvironment {
    return this.env;
  }

  public load(): Observable<IEnvironment> {
    const url = '/assets/config.json';
    return this.http.get<IEnvironment>(url).pipe(
      tap((config) => {
        config = this.pcObjectStringConvert.convertStringBooleansToBooleans(config);
        this.env = config;
        this.tagInjectorService.addMetaTagSecurityPolicy(config.contentSecurityPolicy);
        this.initializeRecaptcha();
      }),
      switchMap((config) => {
        const defaultLang = config.language.defaultLang || LanguageCode.EN_AU;
        const langs = config.language.allLanguages || [LanguageCode.EN_AU, LanguageCode.EN_US];

        return new TranslationLoader().getTranslation(defaultLang).pipe(
          switchMap(() => this.translation.init(defaultLang, langs)),
          map(() => config)
        );
      })
    );
  }
  private initializeRecaptcha(): void {
    const recaptchaSiteKey = this.env.recaptcha.siteKey;
    if (recaptchaSiteKey) {
      this.tagInjectorService.injectScriptElement(`${ERecaptchaEnum.URL}${recaptchaSiteKey}`);
      this.recaptchaService.key = recaptchaSiteKey;
    }
  }
}
